import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Navbar } from "@/components/Navbar";

export default function PaymentCancel() {
  return (
    <main className="min-h-screen flex flex-col" data-testid="payment-cancel-page">
      <Navbar />
      <div className="flex-1 flex items-center justify-center relative overflow-hidden px-6 pt-20">
        <div className="spotlight absolute inset-0" aria-hidden="true" />
        <motion.div initial={{ opacity: 0, y: 32 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="relative z-10 text-center py-24">
          <h1 className="font-serif font-medium text-5xl text-zinc-900">Checkout <em className="text-gold">paused</em>.</h1>
          <p className="text-zinc-500 mt-6 max-w-md mx-auto">No charge was made. Your bag is saved — return whenever you're ready.</p>
          <div className="flex items-center justify-center gap-8 mt-12">
            <Link to="/shop" data-testid="cancel-back-to-shop" className="bg-gold text-white text-xs uppercase tracking-[0.3em] px-10 py-4 hover:bg-champagne transition-colors duration-300">
              Back to the Collection
            </Link>
          </div>
        </motion.div>
      </div>
    </main>
  );
}
